var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSynergiesCloseSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.275 2.089l12.728 12.728",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.96.195A5.433 5.433 0 0010.5 0a5.433 5.433 0 00-2.773.75A5.59 5.59 0 005.75 2.727c-.184.31-.335.64-.454.989l.808.807c.058-.265.14-.523.248-.773A4.515 4.515 0 018.75 1.36C9.297 1.12 9.88 1 10.5 1c.62 0 1.203.12 1.75.36a4.515 4.515 0 011.43.96c.406.407.726.883.96 1.43.24.547.36 1.13.36 1.75 0 .62-.12 1.203-.36 1.75a4.516 4.516 0 01-3.163 2.646l.807.808c.348-.119.678-.27.99-.454a5.589 5.589 0 001.977-1.977 5.431 5.431 0 00.749-2.773 5.433 5.433 0 00-1.617-3.883A5.4 5.4 0 0011.96.195zM9.695 10.942L7.969 9.218A4.514 4.514 0 016.782 8.03L5.058 6.306c.053.365.143.721.27 1.069.219.594.534 1.14.945 1.64L.148 15.149A.48.48 0 000 15.5c0 .135.05.253.148.352A.48.48 0 00.5 16a.48.48 0 00.352-.148l6.132-6.125c.5.411 1.047.726 1.641.945a5.37 5.37 0 001.069.27z",
    fill: "currentColor"
  })));
}

export default SvgSynergiesCloseSearch;